import { render, staticRenderFns } from "./shareAdjustment.vue?vue&type=template&id=7c31c776&scoped=true&"
import script from "./shareAdjustment.vue?vue&type=script&lang=js&"
export * from "./shareAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./shareAdjustment.vue?vue&type=style&index=0&id=7c31c776&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c31c776",
  null
  
)

export default component.exports